<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Container, Checkbox, Input, InputV2, Tooltip, Alert } from '@Shelly/shelly-design-system';
	// helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { capFirstChar } from 'src/helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let isOffline: boolean = false;
	export let ssid: string,
		pass: string = '',
		is_open = false,
		is_open_enabled = true,
		readonly = null,
		save_pass_enabled = false,
		savePass = false,
		removeBottomPadding = false,
		removePaddings = false;

	export let withoutBackground: boolean = false;
	export let disableForm: boolean = false;

	ssid = ssid || '';
	pass = pass || '';

	// Force is_open to false when open network option is disabled (secure provisioning)
	$: if (!is_open_enabled) {
		is_open = false;
	}

	export let showAlert: boolean = false;

	export const validate = () => {
		errors.ssid = ssid == '' || ssid.length > 31;
		errors.pass = !is_open && pass.length < 8;
		return errors.ssid || errors.pass ? false : { ssid, pass: is_open ? '' : pass, is_open };
	};

	export const reset = () => {
		pass = '';
		errors = { ssid: false, pass: false };
	};

	$: InputC = $showNewLayout ? InputV2 : Input;

	let errors = { ssid: false, pass: false };
	const errorsLabels = {
		ssid: $format('wifi_ssid_length_err_toast', {
			default: 'Not a valid SSID format. It must be between 1 and 31 characters.',
		}),
		pass: $format('wifi_pass_length_err_toast', {
			default: 'Password should be at least 8 characters long.',
		}),
	};
</script>

<!-- This where this is used is it ok removing paddings here globally -->
<Container
	class={classMap({
		'mb-s': !removeBottomPadding,
		'border-color-transparent': withoutBackground,
	})}
	padding={withoutBackground || removePaddings ? '0' : 'xs'}
	type={withoutBackground ? 'borderDashed' : 'base'}
	noScroll
>
	{#if !isOffline && showAlert}
		<Alert
			type="warning"
			class={classMap({
				'mb-s': !$showNewLayout,
				'mb-s-plus': $showNewLayout,
			})}
			heading={$format('alert_heading_cant_connect_to_open_network', {
				default: 'You can’t connect to an open network because this device is cloud enabled.',
			})}
		/>
	{/if}
	<Tooltip
		placement="top"
		title={readonly ? $format('placeholder_ssid', { default: 'SSID' }) : ''}
		class="width-full"
	>
		<svelte:component
			this={InputC}
			aria-labelledby="input-j6fxfl6"
			size="m"
			class="mb-s"
			label="SSID"
			bind:value={ssid}
			disabled={disableForm}
			error={errors.ssid ? errorsLabels.ssid : ''}
			icon="fas fa-wifi"
			on:input={() => (errors.ssid = false)}
			{readonly}
			id="input-j6fxfl6"
		/>
	</Tooltip>

	<svelte:component
		this={InputC}
		aria-labelledby="input-cm9pa8z"
		a11yProps={{
			iconButtonAriaLabel: capFirstChar($format('label_password', { default: 'password' })),
		}}
		size="m"
		class={is_open_enabled || save_pass_enabled ? 'mb-s' : null}
		bind:value={pass}
		label={capFirstChar($format('label_password', { default: 'Password' }))}
		disabled={is_open || disableForm}
		error={!is_open && errors.pass ? errorsLabels.pass : ''}
		type="password"
		icon="fas fa-lock-keyhole"
		on:input={() => (errors.pass = false)}
		id="input-cm9pa8z"
	/>

	{#if is_open_enabled}
		<Checkbox
			size="m"
			bind:checked={is_open}
			on:click={reset}
			disabled={disableForm}
			id="checkbox-1yexp6i"
		>
			{$format('wifi_open_network', { default: 'Open network' })}
		</Checkbox>
	{/if}

	{#if save_pass_enabled}
		{#if disableForm || is_open}
			<Checkbox size="m" checked={false} disabled={true} id="checkbox-hs1t7no">
				{$format('label_save_password', { default: 'Save password' })}
			</Checkbox>
		{:else}
			<Checkbox size="m" bind:checked={savePass} id="checkbox-rgal5ln">
				{$format('label_save_password', { default: 'Save password' })}
			</Checkbox>
		{/if}
	{/if}
</Container>
